import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import './loadingBtn.scss';
import './style.scss';

const useStyle = makeStyles({
	button: () => ({
		height: '49px',
		borderRadius: 12,
		margin: 0,
		paddingTop: 10,
		fontWeight: 700,
		width: '100%',
		fontSize: 16,
		boxShadow: 'none',
	}),
});

export default function Contained(props) {
	const { children, disabled, onClick, isLoading, bgColor, style, startIcon, variant, rest } = props;

	const classes = useStyle();
	return (
		<section id="btn-contained">
			<Button
				className={classes.button}
				variant={variant}
				color={props.color || 'primary'}
				disabled={isLoading || disabled}
				style={
					bgColor
						? {
								backgroundColor: bgColor,
								...style,
						  }
						: style
				}
				onClick={onClick}
				startIcon={startIcon}
				{...rest}
			>
				{children}
				{isLoading ? (
					<>
						<div className="loader">
							<div></div>
							<div></div>
							<div></div>
							<div></div>
						</div>
					</>
				) : null}
			</Button>
		</section>
	);
}

Contained.defaultProps = {
	disabled: false,
	isLoading: false,
	variant: 'contained',
};
